import styled from 'styled-components';

export const MessageNewSystemStyle = styled.div`
  position: absolute;
  top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  background-color: ${({ theme }) => {
    return theme.colors.backgroundForm;
  }};
  border: ${({ theme }) => {
    return theme.border;
  }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  div {
    display: flex;
    width: 100%;
    align-items: center;
    background-color: ${({ theme }) => {
      return theme.colors.alert;
    }};
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      width: 30px;
      background-color: ${({ theme }) => {
        return theme.colors.darkAlert;
      }};
      img {
        width: 18px;
      }
    }
    h3 {
      margin: 5px auto;
      font-size: ${({ theme }) => {
        return theme.fonts.size.normal;
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin;
      }};
    }
  }
  p {
    margin: 5px;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
  a {
    margin: 10px;
    padding: 5px;
    width: 90%;
    text-decoration: none;
    text-align: center;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    :hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkPrimary;
      }};
    }
  }
`;
